const base = "cui-list-9zvq";
const l = "cui-list-l-bgvx";
const m = "cui-list-m-xr1c";
const s = "cui-list-s-equv";
const classes = {
  base,
  l,
  m,
  s
};
export {
  base,
  classes as default,
  l,
  m,
  s
};
